import { render } from "./LandUseModal.vue?vue&type=template&id=56ada66d&scoped=true"
import script from "./LandUseModal.vue?vue&type=script&lang=js"
export * from "./LandUseModal.vue?vue&type=script&lang=js"

import "./LandUseModal.vue?vue&type=style&index=0&id=56ada66d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ada66d"]])

export default __exports__